/*es6-set/lib/iterator*/
function _(require, module, exports) {
    var setPrototypeOf = require(301    /* es5-ext/object/set-prototype-of */), contains = require(307    /* es5-ext/string/#/contains */), d = require(268    /* d */), Iterator = require(315    /* es6-iterator */), toStringTagSymbol = require(325    /* es6-symbol */).toStringTag, defineProperty = Object.defineProperty, SetIterator;
    SetIterator = module.exports = function (set, kind) {
        if (!(this instanceof SetIterator))
            return new SetIterator(set, kind);
        Iterator.call(this, set.__setData__, set);
        if (!kind)
            kind = 'value';
        else if (contains.call(kind, 'key+value'))
            kind = 'key+value';
        else
            kind = 'value';
        defineProperty(this, '__kind__', d('', kind));
    };
    if (setPrototypeOf)
        setPrototypeOf(SetIterator, Iterator);
    SetIterator.prototype = Object.create(Iterator.prototype, {
        constructor: d(SetIterator),
        _resolve: d(function (i) {
            if (this.__kind__ === 'value')
                return this.__list__[i];
            return [
                this.__list__[i],
                this.__list__[i]
            ];
        }),
        toString: d(function () {
            return '[object Set Iterator]';
        })
    });
    defineProperty(SetIterator.prototype, toStringTagSymbol, d('c', 'Set Iterator'));
}